/* eslint-disable @fx-ui/jdy-design/no-blacklist-constant */
/**
 * jssdk 脚本cdn地址
 * https://fanruan-x.feishu.cn/wiki/FE5xwC1FfilwIpkHV7Wc0XdmnDb 3.3.2
 */
export const JSSDK_URL = {
    App: {
        Jdy: 'https://g.jdycdn.com/jssdk/fx-sdk-0.3.2.min.js',
        Jodoo: 'https://g.jodoo-cdn.com/jssdk/fx-sdk-0.3.2.min.js'
    },
    Dingtalk: 'https://g.alicdn.com/dingding/dingtalk-jsapi/3.0.42/dingtalk.open.js',
    Lark: 'https://lf-scm-cn.feishucdn.com/lark/op/h5-js-sdk-1.5.38.js',
    WxWork: {
        Base: 'https://wwcdn.weixin.qq.com/node/wework/wwopen/js/wecom-jssdk-2.4.0.js',
        // 浏览器中加载 WWOpenData 还是依赖该脚本
        Agent: 'https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js'
    },
    WeChat: 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js'
};
